/* eslint-disable no-undef */
import { onFirstInteraction } from '../../inventory-json';

const EventBus = window.EventBus;
export const Omnisearch = {
  props: {
    results: Array,
    lang: String,
    templatedir: String,
    showvin: {
      type: Boolean,
      default: true
    },
    usevin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chosen: '',
      loading: false,
      inventoryLoaded: false,
      selected: null,
      model: null,
      initialResultset: [],
      inputValue: '',
      hasSuggestions: false,
      searchDebounceTimer: null,
      lastTrackedOmniSearch: ''
    }
  },
  watch: {
    model(newVal) {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }
      this.searchDebounceTimer = setTimeout(() => {
        if (!newVal || newVal.trim() === '' || newVal.length < 3) {
          this.lastTrackedOmniSearch = '';
          return;
        }
        if (newVal === this.lastTrackedOmniSearch) return;
        this.lastTrackedOmniSearch = newVal;

        // LBT-1602 (M2): the omni search reported open and close but never the
        // search itself, so element_action 'search' was one of the values the
        // spec defines and nothing ever emitted.
        //
        // This is a type-ahead with no submit button, so "the user searched" is
        // the query settling rather than a form submit. Reusing the existing
        // debounce and dedupe guards above means one event per search instead
        // of one per keystroke — and the < 3 character early return keeps
        // partial words out.
        if (window.LBX && window.LBX.track && typeof window.LBX.track.uiInteraction === 'function') {
          window.LBX.track.uiInteraction({
            element_type: 'search',
            element_name: 'omni_search',
            element_action: 'search',
            element_text: newVal,
            element_position: 'header',
            element_url: null
          });
        }

        var jlr_script = document.getElementById("shiftdigital-script");
        if (jlr_script != null) {
          sd('dataLayer', {
            typedSearchContent: newVal.replaceAll(" ", "|"),
            events: 'typedSearch'
          });
          sd('send');
        }
      }, 500);
    }
  },
  mounted() {
    this.observeSuggestions();
    onFirstInteraction(() => this.httpRequestInventory(), this.$el, ['pointerover', 'pointerdown', 'focusin', 'touchstart', 'keydown']);
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.targetObserver) {
      this.targetObserver.disconnect();
    }
  },
  methods: {
    toLeadboxImageUrl(src, size = '400-300') {
      if (!src) return null;

      if (src.includes('vehicleimages.leadboxhq.com')) {
        return src.replace('http:', 'https:');
      }
      const m = src.match(
        /https?:\/\/[^/]*blob\.core\.windows\.net\/([^/]+)\/vehicles\/([^/]+)\/pictures\/([a-f0-9-]+)(?:-[A-Z]+)?(?:\.\w+)?$/i
      );
      if (!m) return null;

      const dealer = m[1];
      const vehicleId = m[2];
      const imageId = m[3];

      return `https://vehicleimages.leadboxhq.com/v1/${dealer}/${vehicleId}/${imageId}-${size}.jpg`;
    },
    observeSuggestions() {
      const targetNode = this.$el.querySelector('.vue-simple-suggest.designed');
      if (!targetNode) return;

      this.targetObserver = new MutationObserver(() => {
        const suggestionsNode = targetNode.querySelector('ul.suggestions');
        if (suggestionsNode) {
          this.hasSuggestions = suggestionsNode.children.length > 0;
        }else{
          this.hasSuggestions = false;
          let rs = document.getElementsByClassName('result-button');
          if (rs && rs.length > 0) {
            if (this.inputValue.length >= 3) {
              document.body.removeChild(rs[0]);
            }
          }
        }
      });

      this.targetObserver.observe(targetNode, { childList: true, subtree: true });
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      let rs = document.getElementsByClassName('result-button');
      if (rs && rs.length > 0) {
        if (this.inputValue.length >= 3) {
          document.body.removeChild(rs[0]);
        }
      }
    },
    httpRequestInventory() {
      this.loading = true;
      //EventBus.httpRequestInventory(null, this.entryPoint, this.gutembergOptions);
      EventBus.getAllInventory(this.entryPoint);
    },
    entryPoint(inventory) {
      this.inventoryLoaded = true;
      this.loading = false;
      this.initialResultset = this.format(inventory);

      const suggest = this.$refs.suggestComponent;
      if (suggest && suggest.text && suggest.text.length >= 3)
        suggest.research();
    },
    onRequestStart() {
      this.loading = true
    },
    goto(url) {
      window.open(url, '_self').focus();
    },
    onPress() {
      let rs = document.getElementsByClassName('result-button');
      if (rs && rs.length > 0) {
        let vm_button = document.querySelector('#result-button-link');
        vm_button.href = this.path + this.inputValue + '/';
        if (this.inputValue.length < 3 || this.$refs.suggestComponent.suggestions.length == 0) {
          document.body.removeChild(rs[0]);
        }
      }
      else {
        if (this.inputValue.length >= 3 && this.$refs.suggestComponent.suggestions.length > 0) {
          const element = document.querySelector('.suggestions');
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          var $suggestionsDiv = document.createElement('div');
          $suggestionsDiv.setAttribute('class', 'absolute result-button w-full flex justify-center p-4 bg-white shadow-md z-50');
          $suggestionsDiv.setAttribute('id', 'result-button');
          $suggestionsDiv.style.top = (offsetTop + offsetHeight + 92) + 'px';
          $suggestionsDiv.innerHTML = '<a href="' + this.path + this.inputValue + '/" class="p-4 bg-dark text-sm font-primary-bold text-white" id="result-button-link">View More Vehicles</a>';
          document.body.appendChild($suggestionsDiv);
        }
      }
    },
    onClick() {
      let rs = document.getElementsByClassName('result-button');
      if (rs && rs.length > 0) {
        return false;
      } else {
        const element = document.querySelector('.suggestions');
        const offsetTop = element.offsetTop;
        const offsetHeight = element.offsetHeight;

        var $suggestionsDiv = document.createElement('div');
        $suggestionsDiv.setAttribute('class', 'absolute result-button w-full flex justify-center p-4 bg-white shadow-md z-50');
        $suggestionsDiv.setAttribute('id', 'result-button');
        $suggestionsDiv.style.top = (offsetTop + offsetHeight + 92) + 'px';
        $suggestionsDiv.innerHTML = '<a href="' + this.path + this.inputValue + '/" class="p-4 bg-dark text-sm font-primary-bold text-white" id="result-button-link">View More Vehicles</a>';
        document.body.appendChild($suggestionsDiv);
      }
    },
    onClickOutside() {
      let rs = document.getElementsByClassName('result-button');
      if (rs && rs.length > 0) {
        if (this.inputValue.length >= 3) {
          document.body.removeChild(rs[0]);
        }
      }
    },
    onSuggestSelect() {
      if (this && this.model && this.model != null && this.model != undefined) {

        var itemSlug = this.path + this.model.replace(/ /g, '_').toLowerCase();
        this.initialResultset.forEach($item => {
          if ($item.title.split("Vin").length > 0) {
            if ($item.title.split("Vin")[1].replace('#','').toLowerCase().trim() == this.model.toLowerCase().trim())
              itemSlug = $item.slug;
          }
        });

        if (this.$refs.suggestComponent.selected != null)
          itemSlug = this.$refs.suggestComponent.selected.slug;

        console.log('ITEM SLUG: ' + itemSlug);

        var payload = { 'event_category': 'LBX-SRP', 'event_label': ' LBX-' + this.model };
        window.sendGAEvent('LBX-Search', payload);
        // similar behavior as clicking on a link
        jQuery("#search").attr("disabled", "disabled");

        var jlr_script = document.getElementById("shiftdigital-script");

        if (jlr_script != null) {
          sd('dataLayer', {
            typedSearchContent: this.model.replaceAll(" ", "|"),
            events: 'typedSearch'
          });
          sd('send');
        }

        window.location.href = itemSlug;
      }
    },
    onRequestDone() {
      this.loading = !this.inventoryLoaded
    },
    onRequestFailed() {
      this.loading = !this.inventoryLoaded
    },
    customFilter(el, value) {
      //console.log(el.title);
      //console.log(value);

      var text = el.title;
      var searchWords = (value && value.length > 0) ? value.trim().split(' ') : [];
      var total = 0;
      //console.log('INIT TOTAL FOUND: ' + total + ' TOTAL ARRAY: ' + searchWords.length);
      //|| (vehicle.model.toLowerCase().split(' ').join('').indexOf(model.toLowerCase().split(' ').join('')) !== -1)
      // || (vehicle.model.toLowerCase().split('-').join('').indexOf(model.toLowerCase().split('-').join('')) !== -1)
      for (var j = 0; j <= searchWords.length; j++) {
        if (text && searchWords && searchWords[j] &&
          (text.toLowerCase().indexOf(searchWords[j].toLowerCase()) !== -1
            || text.toLowerCase().split(' ').join('').indexOf(searchWords[j].toLowerCase().split(' ').join('')) !== -1
            || text.toLowerCase().split('-').join('').indexOf(searchWords[j].toLowerCase().split('-').join('')) !== -1
          )
        )
          total++;
      }

      //console.log('TOTAL FOUND: ' + total + ' TOTAL ARRAY: ' + searchWords.length);
      if (total == searchWords.length) {
        return true;
      }
      else {
        return false;
      }

    },
    onSuggestClick(suggest) {
      //alert( "VALUE SELECTED: " + suggest);
      var payload = { 'event_category': 'LBX-SRP', 'event_label': ' LBX-' + suggest };
      window.sendGAEvent('LBX-Search', payload);

      // similar behavior as clicking on a link
      window.location.href = this.path + suggest.replace(/ /g, '_').toLowerCase();
    },
    simpleSuggestionList() {
      return this.initialResultset;
    },
    format(list) {
      var $filtered = [];
      list.forEach($item => {
        var $text;
        if (this.lang == 'fr_CA') {
          $text = (($item.make) ? $item.make + ' ' : '') +
            (($item.model) ? $item.model + ' ' : '') +
            (($item.productline) ? $item.productline + ' ' : '') +
            (($item.trim) ? $item.trim + ' ' : '') +
            (($item.year) ? $item.year + ' ' : '') +
            (($item.condition) ? this.$t($item.condition) + ' ' : '') +
            (($item.stocknumber) ? ' Stock #' + $item.stocknumber : '') +
            (this.showvin ? (($item.vin) ? ' Vin #' + $item.vin : '') : '');
        } else {
          $text = (($item.condition) ? this.$t($item.condition) + ' ' : '') +
            (($item.year) ? $item.year + ' ' : '') +
            (($item.make) ? $item.make + ' ' : '') +
            (($item.model) ? $item.model + ' ' : '') +
            (($item.productline) ? $item.productline + ' ' : '') +
            (($item.trim) ? $item.trim + ' ' : '') +
            (($item.stocknumber) ? ' Stock #' + $item.stocknumber : '') +
            (this.showvin ? (($item.vin) ? ' Vin #' + $item.vin : '') : '');
        }

        if ($item.picture && $item.picture.includes("-XXL"))
          $item.picture = this.toLeadboxImageUrl($item.picture, '130');

        $filtered.push({
          id: $item.id,
          condition: $item.condition,
          year: $item.year,
          make: $item.make,
          model: $item.model,
          bodystyle: $item.bodystyle,
          exteriorcolor: $item.exteriorcolor,
          transmission: $item.transmission,
          mileage: $item.mileage,
          title: $text,
          name: (($item.year) ? $item.year + ' ' : '') + (($item.make) ? $item.make + ' ' : '') + (($item.model) ? $item.model + ' ' : '') + (($item.trim) ? $item.trim + ' ' : '') + (($item.trimdescription) ? $item.trimdescription + ' ' : ''),
          vin: $item.vin,
          trim: $item.trim,
          trimdescription: $item.trimdescription,
          stocknumber: $item.stocknumber,
          slug: this.viewSlug($item),
          picture: $item.picture,
          price: $item.price
        })
      });
      return $filtered;
    },
    viewSlug(item) {
      let slug = "/view/";
      if (this.lang == 'fr_CA')
        slug = "/vue/";

      return slug +
        item.condition.toLowerCase().replace(/ /g, "-") + "-" +
        item.year.toLowerCase().replace(/ /g, "-") + "-" +
        item.make.toLowerCase().replace(/ /g, "-") + "-" +
        item.model.toLowerCase().replace(/ /g, "-").replace('/', '') + "-" +
        (this.usevin ? (item.vin.toLowerCase().replace(/ /g, "-") + "-") : "") +
        item.id;
    },
    imgLoadOnError(id) {
      if (id) {
        this.$refs[id + "omnisearch-main-img"].src = this.templatedir;
      }
    },
  },
  computed: {
    path() {
      if (this.lang == 'fr_CA')
        return '/recherche/filter/';
      else
        return '/search/filter/';
    },
    gutembergOptions() {
      return { "year": "all", "make": "all", "model": "all", "trim": "all", "price": "all", "mileage": "all", "type": "all", "status": "all", "tags": "all", "stock": "all", "filter": true, "limit": "0", "sort_by": "year", "sort_by_condition": "desc", "flags": "none", "layout": "normal", "location": "all" }
    }
  },
}
